export default __webpack_public_path__ + "static/media/icon-search.09900c2e.svg";